import React from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import TeamForm from '../Form';
import { createTeam } from '@resources/Team/actions';
import { useIntl } from 'react-intl';
import { fetchModulesBySubmoduleCode } from '@resources/Module/actions';

const Create = (props) => {
	const { createTeam, visible, onCancel, module } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createTeam(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.team.create',
						defaultMessage:
							'A new Team has been successfully created',
					})
				);
				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.team',
					defaultMessage: 'Create Team',
				})}
			</Title>
			<TeamForm onSubmit={handleSubmit} {...props} module={module} />
		</Modal>
	);
};

const mapStateToProps = ({
	teams,
	modules,
	event,
	facility,
	ministry,
	cellGroup,
	organization,
}) => {
	return {
		teams,
		ministry,
		facility,
		modules,
		event,
		cellGroup,
		organization,
	};
};

export default connect(mapStateToProps, {
	createTeam,
	fetchModulesBySubmoduleCode,
})(Create);
